"use client";
import React, { memo } from "react";

import { BANNER_BUTTON_ID_TEXT } from "./constants";
import {
    SIGN_UP_ENDPOINT,
    SURVEY_START_SECTIONS,
} from "../../../public/Constants/EnumConstants";
import HlsJsPlayer from "../../Atoms/HlsJsPlayer/HlsJsPlayer";
import { GoogleTagManagerEvents } from "../../../common";
import NewHeroDescription from "../../Atoms/Typography/NewHeroDescription";
import NewPrimaryButtonWrapper from "../../Atoms/Buttons/NewPrimaryButtonWrapper";
import NewHeroText from "../../Atoms/Typography/NewHeroText";
import Link from "next/link";
import { PRIMARY_BUTTON_CLASS } from "../../Atoms/Buttons/NewPrimaryButton/styles";
import Image from "next/image";
import { useIntersectionObserver } from "@uidotdev/usehooks";

const VideoComp = memo(({ videoUrl, videoAlt, poster }) => {
    const [ref, entry] = useIntersectionObserver({
        threshold: 0,
        root: null,
        rootMargin: "0px",
    });
    return (
        <div ref={ref}>
            <video
                autoPlay
                muted
                loop
                controls={false}
                // src={entry?.isIntersecting ? videoUrl : null}
                alt={videoAlt}
                poster={poster}
                className="w-full"
            />
        </div>
    );
});

const BannerSection = ({ data }) => {
    return (
        <div className={"relative"}>
            <div className={"relative h-auto"}>
                {/* {data?.banner_video?.url ? (
                    <HlsJsPlayer
                        autoPlay={true}
                        containerClassName={
                            "min-w-screen !w-full mx-auto h-auto hidden md:block"
                        }
                        source={data?.banner_video?.url}
                        videoPlaceHolder={data?.banner_image?.url}
                        alt={data?.mobile_banner_image?.alt}
                        videoClassName={"w-full"}
                    />
                ) : ( */}
                {data?.banner_video?.url ? (
                    <div className="relative min-w-screen !w-full aspect-[16/9] hidden md:block">
                        <VideoComp
                            videoUrl={data?.banner_video?.url}
                            videoAlt={data?.banner_video?.alt}
                            poster={data?.banner_image?.url}
                        />
                    </div>
                ) : data?.banner_image?.url ? (
                    <div className="relative min-w-screen !w-full aspect-[16/9] hidden md:block">
                        <Image
                            layout="fill"
                            alt={data?.banner_image?.alt || "Banner Image"}
                            src={data?.banner_image?.url}
                            className="object-cover"
                        />
                    </div>
                ) : null}
                {/* )}a
                {data?.mobile_banner_video?.url ? (
                    <HlsJsPlayer
                        autoPlay={true}
                        containerClassName={
                            "min-w-screen !w-full h-auto block md:hidden"
                        }
                        source={data?.mobile_banner_video?.url}
                        videoPlaceHolder={data?.mobile_banner_image?.url}
                        alt={data?.mobile_banner_image?.alt}
                        videoClassName={"w-full"}
                    />
                ) : ( */}
                {data?.mobile_banner_video?.url ? (
                    <div className="min-w-screen !w-full h-auto block md:hidden">
                        <VideoComp
                            videoUrl={data?.mobile_banner_video?.url}
                            videoAlt={data?.mobile_banner_video?.alt}
                            poster={data?.mobile_banner_image?.url}
                        />
                        {/* <video
                            autoPlay
                            muted
                            controls={false}
                            src={data?.mobile_banner_video?.url}
                            alt={data?.mobile_banner_video?.alt}
                            poster={data?.mobile_banner_image?.url}
                        /> */}
                    </div>
                ) : data?.mobile_banner_image?.url ? (
                    <div className="min-w-screen !w-full aspect-[9/16] block md:hidden ">
                        <Image
                            fill
                            alt={
                                data?.mobile_banner_image?.alt || "Banner Image"
                            }
                            src={data?.mobile_banner_image?.url}
                            className="object-cover"
                        />
                    </div>
                ) : null}
            </div>
            <div
                className={
                    "absolute  min-h-[485px] top-0 left-0 h-[100%] w-[100%] text-center flex justify-center !items-center"
                }
            >
                <div
                    className={
                        "grid grid-cols-1 text-center bg-opacity-60 justify-center !items-center align-middle mx-[2%] sm:mx-[15%] md:mx-[16%] lg:mx-[15%] 2xl:mx-[25%]  md:my-[8%] xl:my-[12%] 2xl:my-[15%]  p-5 absolute md:static bottom-[90px] md:bottom-auto"
                    }
                >
                    <NewHeroDescription text={data?.description} />
                    <NewHeroText text={data?.title} />
                    <NewHeroDescription
                        text={data?.tag_line}
                        customStyles={"mx-4 not-italic"}
                    />
                    {data?.button_text && (
                        <div className={"mt-6 mb-5"}>
                            <Link
                                href={
                                    data?.button_link ||
                                    `${SIGN_UP_ENDPOINT}?from=${SURVEY_START_SECTIONS?.HomeBanner}`
                                }
                                className={PRIMARY_BUTTON_CLASS}
                            >
                                {data?.button_text || "Start The Style Quiz"}
                            </Link>
                            {/* <NewPrimaryButtonWrapper
                                place="home-page-banner"
                                event={
                                    GoogleTagManagerEvents.navigationInteractions
                                }
                                menuName={SURVEY_START_SECTIONS?.HomeBanner}
                                text={data?.button_text}
                                href={SIGN_UP_ENDPOINT}
                                prefetch={true}
                                section={SURVEY_START_SECTIONS?.HomeBanner}
                                buttonId={BANNER_BUTTON_ID_TEXT}
                            /> */}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BannerSection;
